<template>
    <router-view />
</template>

<script>
export default {
    name: 'CommodityListLayout',
};
</script>

<style scoped></style>
